<template>
  <div>
    <loading :active.sync="loading"></loading>
    <form v-on:submit.prevent v-if="!showConfirmationForm">
      <div class="form-group">
        <label for="loginEmail">Email Address</label>
        <input v-model="userName"
               class="form-control"
               id="loginEmail"
               placeholder="Enter Email">
      </div>
      <div class="form-group homapt-signup-section">
        <label for="login">Password</label>
        <input v-model="password"
               v-on:keydown.enter="onLogIn"
               type="password"
               class="form-control"
               id="login"
               placeholder="Enter Password">
        <label v-if="!getLoginMode" for="verifySignupPassword">Verify Password</label>
        <input v-model="verifyPassword"
               v-on:keydown.enter="onSignUp"
               v-if="!getLoginMode"
               type="password"
               class="form-control"
               id="verifySignupPassword"
               placeholder="Verify Password">
        <div v-if="!getLoginMode && password">
          <p class="homapt-signup-section" v-bind:class="{ 'green-colored': longEnough, 'red-colored': !longEnough }">
            <span v-if="longEnough">&#10003;</span><span v-if="!longEnough">&#10006;</span> At least 8 characters</p>
          <p class="homapt-signup-section" v-bind:class="{ 'green-colored': hasNumber, 'red-colored': !hasNumber }">
            <span v-if="hasNumber">&#10003;</span><span v-if="!hasNumber">&#10006;</span> At least one number</p>
          <p class="homapt-signup-section" v-bind:class="{ 'green-colored': hasSpecialChar, 'red-colored': !hasSpecialChar }">
            <span v-if="hasSpecialChar">&#10003;</span><span v-if="!hasSpecialChar">&#10006;</span> At least one special character</p>
          <p class="homapt-signup-section" v-bind:class="{ 'green-colored': hasUpper, 'red-colored': !hasUpper }">
            <span v-if="hasUpper">&#10003;</span><span v-if="!hasUpper">&#10006;</span> Contains upper case letters</p>
          <p class="homapt-signup-section" v-bind:class="{ 'green-colored': hasLower, 'red-colored': !hasLower }">
            <span v-if="hasLower">&#10003;</span><span v-if="!hasLower">&#10006;</span> Contains lower case letters</p>
          <p class="homapt-signup-section" v-bind:class="{ 'green-colored': passwordsMatch, 'red-colored': !passwordsMatch }">
            <span v-if="passwordsMatch">&#10003;</span><span v-if="!passwordsMatch">&#10006;</span> Passwords match</p>
        </div>
        <div class="homapt-button-wrapper">
          <hom-apt-button v-on:click.native="onLogIn" v-if="getLoginMode" buttonText="Login"></hom-apt-button>
          <hom-apt-button v-on:click.native="onSignUp" v-if="!getLoginMode" buttonText="Sign Up"></hom-apt-button>
        </div>
        <router-link to="/forgotpassword">
          <div v-on:click="$emit('hide-modal')" id="forgotPassword" v-if="getLoginMode" class="form-text forgot-password">Forgot Password?</div>
        </router-link>
      </div>
    </form>
    <form v-on:submit.prevent v-if="showConfirmationForm">
      <label for="confirmation-code">Confirmation Code Sent To:<br><strong>{{ userName }}</strong></label>
      <input v-model="confirmationCode"
             id="confirmation-code"
             class="form-control"
             placeholder="Enter Confirmation Code">
      <button type="submit" v-on:click="submitConfirmationCode" class="btn btn-primary homapt-button-wrapper">Submit Code</button>
    </form>
  </div>
</template>

<script>
import HomAptCognito from '../../store/lib/cognitoLogin.js'
import HomAptButton from './HomAptButton.vue'
import { mapActions, mapGetters } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  data () {
    return {
      loginType: 'email',
      multiFactorAuth: false,
      userName: null,
      password: '',
      confirmationCode: '',
      showConfirmationForm: false,
      verifyPassword: null,
      submitButtonText: 'Log In',
      loading: false
    }
  },
  computed: {
    ...mapGetters('loginModal', [
      'getLoginMode'
    ]),
    longEnough: function () {
      if (this.password.length > 7) {
        return true
      } else {
        return false
      }
    },
    hasNumber: function () {
      return /\d/.test(this.password)
    },
    hasSpecialChar: function () {
      return /[~`!#$%^&*+=\-[\]\\';,/{}|\\":<>?]/g.test(this.password)
    },
    hasUpper: function () {
      return /[A-Z]/.test(this.password)
    },
    hasLower: function () {
      return /[a-z]/.test(this.password)
    },
    passwordsMatch: function () {
      if ((this.password === this.verifyPassword) && (this.password.length > 0)) {
        return true
      } else {
        return false
      }
    }
  },
  components: {
    homAptButton: HomAptButton,
    Loading
  },
  watch: {
    userName: function (value) {
      this.userName = value.toLowerCase()
    }
  },
  methods: {
    ...mapActions([
      'authenticatedLogin'
    ]),
    loginCleanUp () {
      this.confirmationCode = null
      this.showConfirmationForm = false
    },
    async onLogIn () {
      this.$global.gaEvent('userLogin', 'backendCall')
      this.loading = true
      var authData = {
        userName: this.userName,
        password: this.password,
        idProvider: 'cognito'
      }
      try {
        await this.authenticatedLogin(authData)
        this.loginCleanUp()
      } catch (error) {
        if (error.code === 'UserNotConfirmedException') {
          localStorage.clear()
          this.showConfirmationForm = true
        } else {
          console.log(error)
          alert(error.message)
        }
      }
      this.loading = false
    },
    async submitConfirmationCode () {
      this.$global.gaEvent('userSignUpConfirm', 'backendCall')
      this.loading = true
      try {
        await HomAptCognito.confirmRegistrationCognito(this.userName, this.confirmationCode)
        var authData = {
          userName: this.userName,
          password: this.password,
          idProvider: 'cognito'
        }
        this.loginCleanUp()
        await this.authenticatedLogin(authData)
      } catch (error) {
        console.log(error)
        alert(error.message)
        return error
      }
      this.loading = false
    },
    async onSignUp () {
      this.$global.gaEvent('userSignUp', 'backendCall')
      this.loading = true
      var that = this
      if (this.password !== this.verifyPassword) {
        alert('Passwords do not match')
      } else if (this.password === null || this.verifypassword === null) {
        alert('Must enter a password')
      } else {
        var authData = {
          loginType: this.loginType,
          userName: this.userName,
          password: this.password,
          idProvider: 'cognito'
        }
        try {
          await HomAptCognito.signUpCognito(authData)
          that.showConfirmationForm = true
        } catch (error) {
          alert(error.message)
        }
      }
      this.loading = false
    }
  }
}
</script>

<style scoped>
.forgot-password {
  color: #212529;
  margin-top: 1rem;
  text-align: center;
}

.green-colored {
  color: green !important;
}
.red-colored {
  color: red !important;
}
.homapt-signup-section {
  margin-bottom: 0px;
}

.homapt-button-wrapper {
  margin-top: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/authentication/LoginForm.vue